import React from 'react'
import './testimonial.css'
export default function Testimonial() {
  return (
    <div className='testimonial-container'>
      <div className="testimonial-header">
        <h3>Loved by Our Users</h3>
      </div>
      <div className="testimonial-box">
        <div className="testimonial-card">
          <div className="card-header">
            <img src="assets/placeholder/male-placeholder-image.png" alt="" />
            <div className="header-text">
              <p className="username">
                Sarah Mitchell
              </p>
              <p className="user-position">
                Product Manager
              </p>
            </div>
          </div>
          <div className="card-body">
            <p className="user-testimonial">
              FinFlex transformed the way I manage my finances. The intuitive interface and real-time insights make it easy to stay on top of my budget. It’s like having a personal finance expert in my pocket!
            </p>
            <div className="review-icons">
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
            </div>
          </div>
        </div>
        <div className="testimonial-card">
          <div className="card-header">
            <img src="assets/placeholder/male-user-placeholder.png" alt="" />
            <div className="header-text">
              <p className="username">
                James Oliver
              </p>
              <p className="user-position">
                Freelance Designer
              </p>
            </div>
          </div>
          <div className="card-body">
            <p className="user-testimonial">
              As a freelancer, managing multiple income streams used to be a hassle. FinFlex’s e-wallet and budgeting tools have streamlined my finances, saving me time and money every month.
            </p>
            <div className="review-icons">
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
            </div>
          </div>
        </div>
        <div className="testimonial-card">
          <div className="card-header">
            <img src="assets/placeholder/user 1images.png" alt="" />
            <div className="header-text">
              <p className="username">
                Priya Patel
              </p>
              <p className="user-position">
                Marketing Specialis
              </p>
            </div>
          </div>
          <div className="card-body">
            <p className="user-testimonial">
              I love how secure and easy FinFlex is to use. The instant payments and savings features help me stay on track with my financial goals, and the rewards are a great bonus!
            </p>
            <div className="review-icons">
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
            </div>
          </div>
        </div>
        <div className="testimonial-card">
          <div className="card-header">
            <img src="assets/placeholder/user 2images.png" alt="" />
            <div className="header-text">
              <p className="username">
                Michael Brown
              </p>
              <p className="user-position">
                Software Enginee
              </p>
            </div>
          </div>
          <div className="card-body">
            <p className="user-testimonial">
              FinFlex’s multi-currency support has been a game-changer for my travel and remote work lifestyle. It’s fast, reliable, and offers the best exchange rates I’ve found in any app
            </p>
            <div className="review-icons">
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
              <i className='bx bxs-star'></i>
            </div>
          </div>
        </div>
      </div>
      <button>Join us Today</button>
    </div>
  )
}
